const CustomPayment = {
  COD: 'COD',
  BANK_TRANSFER: 'Bank transfer',
  ADYEN: 'ctp-adyen-integration',
};
export default CustomPayment;
